module.exports = __webpack_public_path__ + "img/01889b55361dac4043a269789237f883.png";